export enum WaterMixture {
    Water = "Water",
    Propylenglycol = "Propylenglycol",
    Monoethylenglycol = "Monoethylenglycol"
}